export enum AppPaths {
	LOGIN = 'login',
	RESET_PASSWORD = 'reset-password',
	SET_PASSWORD = 'set-password',

	FORM_TEMPLATES = 'form-templates',
	FORMS = 'forms',
	PROJECTS = 'projects',
	PRODUCT_TYPES = 'product-types',
	PRODUCT_VARIANTS = 'product-variants',
	ATTRIBUTES = 'attributes',
	ATTRIBUTE_VALUES = 'attribute-values',
	CONFIGURATOR_TEMPLATES = 'configurator-templates',
	CONFIGURATOR_RESOURCE_LIBRARY = 'configurator-resource-library',

	CONTENT = 'content',
	ORDERS = 'orders',
	ADMINS = 'admins',
	CLIENTS = 'clients',
	LOGIN_HISTORY = 'login-history',
	ROLES = 'roles',

	GLOBAL_SETTINGS = 'global-settings',
	CONFIGURATOR_LIBRARY = 'configurator-library',
	CONFIGURATOR_LIBRARY_TEMPLATE = 'configurator-library/:templateId',
	CONFIGURATOR_PRESETS = 'configurator-presets',
	CONFIGURATOR_PROJECTS = 'configurator-projects',
	CONFIGURATOR_PRODUCT_DATA = 'configurator-product-data',
	CONFIGURATOR_SETTINGS = 'configurator-settings',
}
